module.exports = __webpack_public_path__ + "static/media/cca.ddcdbdb5.svg";